import "./modules/core"
import initCookiePolicy from "./cookie-policy"

initCookiePolicy()
